/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popPrompt.vue?vue&type=template&id=5f646b0c&scoped=true"
import script from "./popPrompt.vue?vue&type=script&lang=js"
export * from "./popPrompt.vue?vue&type=script&lang=js"
import style0 from "./popPrompt.vue?vue&type=style&index=0&id=5f646b0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f646b0c",
  null
  
)

export default component.exports